import { ServiceException as __ServiceException, } from "@aws-sdk/smithy-client";
export class CognitoIdentityProviderServiceException extends __ServiceException {
    constructor(options) {
        super(options);
        Object.setPrototypeOf(this, CognitoIdentityProviderServiceException.prototype);
    }
}
